import MultiStateSwitch from 'components/MultiStateSwitch/MultiStateSwitch';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import qs from 'qs';
import { useAppDispatch } from 'app/hooks';
import http from 'app/http';

interface Props {
  PageData?: any;
  Model?: any;
  payerReviewViewModel?: any;
}

const PayerReviewPanel = ({ PageData, Model, payerReviewViewModel }: Props) => {
  const [hasPlanVerified, setHasPlanVerified] = useState<boolean>(false);
  const [situationChanged, setSituationChanged] = useState<boolean | undefined>(
    undefined,
  );
  const [planPlanStillAffordable, setPlanStillAffordable] = useState<
    boolean | undefined
  >(undefined);

  const usehistory = useHistory();
  const dispatch = useAppDispatch();

  const getPathnameFromUrl = (url: string) => {
    const link = new URL(url);

    return link.pathname + link.search;
  };
  useEffect(() => {
    if (situationChanged === true) {
      setHasPlanVerified(true);
      setPlanStillAffordable(undefined);
    }
    if (situationChanged === false && planPlanStillAffordable !== undefined) {
      setHasPlanVerified(true);
    }
    if (situationChanged === false && planPlanStillAffordable === undefined) {
      setHasPlanVerified(false);
    }
  }, [situationChanged, planPlanStillAffordable]);

  const submitButtonClick = async (e: any) => {
    e.preventDefault();
    try {
      const response = await http.post(
        Model?.payerReviewViewModel?.SubmitPayerReviewUrl,
        // Convert object into string
        qs.stringify({
          'payerReviewViewModel.SituationChanged': situationChanged,
          'payerReviewViewModel.PlanStillAffordable': planPlanStillAffordable
        }),
        {
          headers: {
            'content-type': 'application/x-www-form-urlencoded',
          },
        },
      );

      if (response && response.data) {

        const nextPagePath = getPathnameFromUrl(response.data);
        usehistory.push(nextPagePath, {
          noRefresh: true,
        });
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <div data-type="Promotion" data-creative-slot="Portal-Home-Top" data-promotion-name="Payer review" >
    <div className="review_wrapper Highlight">
      <form
        className="Form"
        id="payerReviewForm"
        onSubmit={submitButtonClick}
      >
        <h2 className="Heading u-textCenter">
          {PageData?.TimeToReviewPlanHeader}
        </h2>
        <div className="OptionsCards__cardContent">
          <ul className="OptionsCards__list">
            <li className="OptionsCards__listItem">
              {PageData?.TakesLessThanTwoMinutesLabel}
            </li>
            <li className="OptionsCards__listItem">
              {PageData?.AdjustYourPlanToEnsureItsAffordableLabel}
            </li>
            <li className="OptionsCards__listItem">
              {PageData?.UpdateYourPaymentPlanLabel}
            </li>
          </ul>
        </div>

        <div className="section_switch  u-marginB">
          <h3 className="subheading u-textCenter  u-textCenter">
            {PageData?.HasYourSituationChangedLabel}
          </h3>
          <div className="Grid  Grid--white u-paddingVz  Grid--gutterH Grid--alignCenter">
            <div className="Grid-cell u-size3of6 u-md-size4of12 u-paddingHz">
              <MultiStateSwitch
                trueLabel={PageData?.YesLabel || 'Yes'}
                falseLabel={PageData?.NoLabel || 'No'}
                name={payerReviewViewModel?.SituationChanged}
                checked={situationChanged}
                onChange={(e) => setSituationChanged(e)}
              />
            </div>
          </div>
        </div>
        {situationChanged === false && (
          <div className="section_switch u-marginB" id="switch_one">
            <h3 className="subheading u-textCenter  u-textCenter">
              {PageData?.IsYourPlanStillAffordableLabel}
            </h3>
            <div className="Grid  Grid--white u-paddingVz  Grid--gutterH Grid--alignCenter">
              <div className="Grid-cell u-size3of6 u-md-size4of12 u-paddingHz">
                <MultiStateSwitch
                  trueLabel={PageData?.YesLabel || 'Yes'}
                  falseLabel={PageData?.NoLabel || 'No'}
                  name={payerReviewViewModel?.PlanStillAffordable}
                  checked={planPlanStillAffordable}
                  onChange={(val) => setPlanStillAffordable(val)}
                />
              </div>
            </div>
          </div>
        )}
        <p className="reviewpayer_notice">
          {PageData?.TimeToReviewPlanNoticeText}
        </p>

        <div className="u-textCenter u-marginB">
          <button
            type="submit"
            className="Button Noplan-button"
            disabled={!hasPlanVerified}
          >
            <span>{PageData?.ContinueButtonLabel || 'Submit'}</span>
          </button>
        </div>
      </form>
    </div>
    </div>
  );
};

export default PayerReviewPanel;
